module.exports = __webpack_public_path__ + "static/18th-c45a402fef3638919bc27cb95483222e.png";